/**
 * Centralised Swym initialisation — fetches wishlist data once per page load
 * and shares it across PDP, PLP, and header count scripts.
 */
const WISHLIST_NAME = 'My Wishlist';
function dispatchBootstrapped(data) {
  window.__swymData = data;
  window.wishlistId = data.wishlistId;
  window.dispatchEvent(new CustomEvent('swym:bootstrapped', {
    detail: data
  }));
}
function fetchListContents(swat, wishlistId) {
  return new Promise((resolve, reject) => {
    swat.fetchListCtx({
      lid: wishlistId
    }, listContents => resolve(Array.isArray(listContents) ? listContents : []), reject);
  });
}
function ensureWishlist(swat) {
  return new Promise((resolve, reject) => {
    swat.fetchLists({
      callbackFn(lists) {
        const existing = lists && lists.find(list => list.lname === WISHLIST_NAME);
        if (existing && existing.lid) {
          resolve(existing.lid);
          return;
        }
        swat.createList({
          lname: WISHLIST_NAME
        }, newList => {
          if (newList && newList.lid) {
            resolve(newList.lid);
          } else {
            reject(new Error('Swym: failed to create wishlist'));
          }
        }, reject);
      },
      errorFn: reject
    });
  });
}
function bootstrapSwym(swat) {
  if (!swat) return Promise.reject(new Error('Swym not available'));
  window._swat = swat;
  return ensureWishlist(swat).then(wishlistId => fetchListContents(swat, wishlistId).then(listContents => ({
    swat,
    wishlistId,
    listContents
  }))).then(data => {
    dispatchBootstrapped(data);
    return data;
  });
}
window.refreshSwymWishlist = function refreshSwymWishlist() {
  const swat = window._swat;
  const wishlistId = window.wishlistId || window.__swymData && window.__swymData.wishlistId;
  if (!swat || !wishlistId) {
    return window.__swymReady || Promise.reject(new Error('Swym not initialised'));
  }
  return fetchListContents(swat, wishlistId).then(listContents => {
    const data = Object.assign({}, window.__swymData || {}, {
      swat,
      wishlistId,
      listContents
    });
    dispatchBootstrapped(data);
    return data;
  });
};
window.__swymReady = new Promise((resolve, reject) => {
  function onSwymLoadCallback(swat) {
    bootstrapSwym(swat).then(resolve).catch(reject);
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
});
